import { useState } from "react";
import XYZ from "ol/source/XYZ";
import { Tile } from "../../reactOL/layers";

const SatelliteOsmTileLayer = () => {
  const [source] = useState(
    () =>
      new XYZ({
        url: "https://services.arcgisonline.com/arcgis/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
        attributions:
          "Source: Esri, Maxar, Earthstar Geographics, and the GIS User Community",
        maxZoom: 19,
      }),
  );

  return <Tile source={source} />;
};

export default SatelliteOsmTileLayer;
